// src/components/Header.js

import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/naprev.png';

function Header() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 950);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 950);
      if (window.innerWidth > 950) {
        setMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Close menu when route changes
  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const navLinks = [
    { name: 'About Us', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Resources', path: '/resources' },
    { name: 'Contact Us', path: '/contact' }
  ];

  return (
    <header style={styles.header}>
      <div style={styles.container}>
        {/* Logo */}
        <Link to="/" style={styles.logoLink}>
          <img 
            src={logo} 
            alt="NAPREV Logo" 
            style={styles.logoImage} 
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'block';
            }}
          />
          <span style={styles.logoTextFallback}>NAPREV</span>
        </Link>

        {/* Desktop Navigation */}
        {!isMobile && (
          <nav style={styles.desktopNav}>
            {navLinks.map((link, index) => (
              <Link 
                key={index} 
                to={link.path} 
                style={{
                  ...styles.navLink,
                  color: location.pathname === link.path ? '#E1261C' : '#002B49'
                }}
              >
                {link.name}
              </Link>
            ))}
          </nav>
        )}

        {/* Mobile Hamburger Button */}
        {isMobile && (
          <button 
            style={styles.hamburgerBtn} 
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#002B49" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              {menuOpen ? (
                <>
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </>
              ) : (
                <>
                  <line x1="3" y1="12" x2="21" y2="12"></line>
                  <line x1="3" y1="6" x2="21" y2="6"></line>
                  <line x1="3" y1="18" x2="21" y2="18"></line>
                </>
              )}
            </svg>
          </button>
        )}
      </div>

      {/* Mobile Dropdown Menu */}
      {isMobile && menuOpen && (
        <div style={styles.mobileMenu}>
          {navLinks.map((link, index) => (
            <Link 
              key={index} 
              to={link.path} 
              style={{
                ...styles.mobileNavLink,
                backgroundColor: location.pathname === link.path ? '#F3F4F6' : '#FFFFFF',
                color: location.pathname === link.path ? '#E1261C' : '#002B49'
              }}
            >
              {link.name}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
}

const styles = {
  header: {
    backgroundColor: '#FFFFFF',
    borderBottom: '1px solid #E5E7EB',
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
    height: '80px',
    boxSizing: 'border-box'
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 5%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '100%'
  },
  logoLink: {
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center'
  },
  logoImage: {
    maxHeight: '45px',
    width: 'auto',
    display: 'block'
  },
  logoTextFallback: {
    display: 'none',
    fontSize: '28px',
    fontWeight: 'bold',
    color: '#00537A',
    letterSpacing: '1px'
  },
  desktopNav: {
    display: 'flex',
    gap: '35px',
    alignItems: 'center'
  },
  navLink: {
    textDecoration: 'none',
    fontSize: '16px',
    fontWeight: '700',
    transition: 'color 0.2s ease',
    padding: '10px 0'
  },
  hamburgerBtn: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  mobileMenu: {
    position: 'absolute',
    top: '80px', 
    left: 0,
    right: 0,
    backgroundColor: '#FFFFFF',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    flexDirection: 'column',
    borderBottom: '4px solid #E1261C'
  },
  mobileNavLink: {
    textDecoration: 'none',
    fontSize: '18px',
    fontWeight: '600',
    padding: '20px 5%',
    borderBottom: '1px solid #F3F4F6',
    transition: 'background-color 0.2s ease, color 0.2s ease'
  }
};

export default Header;